import 'stylesheets/application.sass'
import { OverlayWidget } from 'widgets'
import { mountOnId } from 'shared'

betterplaceOverlayConfigs.forEach((config) => mountOnId(OverlayWidget, config?.widgetId || '', config, false))
